import React from "react";
import { ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-[#F8FDFF]">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0C3547] to-[#155E75] py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-cyan-300 hover:text-white transition-colors mb-8 text-sm" data-testid="cookie-back-link">
            <ArrowLeft size={18} />
            Vissza a főoldalra
          </Link>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Cookie (Süti) Szabályzat
          </h1>
          <p className="text-cyan-200 mt-4 text-sm md:text-base">Hatálybalépés dátuma: 2026. április 15.</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 md:py-16">
        <div className="prose-policy">
          <p>
            Jelen szabályzat a bazabaukft.hu weboldalon (üzemeltető: Báza-Bau Kft.) alkalmazott sütikre vonatkozik. A weboldal használatával Ön elfogadja a jelen szabályzat rendelkezéseit. Amennyiben nem ért egyet a feltételekkel, kérjük, ne használja a weboldalt.
          </p>

          <h2>1. Mik azok a sütik (cookie-k)?</h2>
          <p>
            A cookie-k kisméretű adatfájlok, amelyeket a weboldal küld a böngészőnek. Segítik a weboldal működését, javítják a felhasználói élményt, és lehetővé teszik a felhasználói viselkedés elemzését, valamint a releváns hirdetések megjelenítését.
          </p>

          <h2>2. Hogyan működik a cookie-k használata?</h2>
          <p>
            A rendszer egy egyedi azonosítót hoz létre, amelyet a böngésző eltárol. Visszatéréskor a böngésző elküldi ezt az azonosítót, így működik például:
          </p>
          <ul>
            <li>Bejelentkezési állapot megjegyzése</li>
            <li>Űrlapértékek tárolása</li>
            <li>Konverziók mérése</li>
            <li>Remarketing-hirdetések</li>
            <li>Személyre szabott tartalom</li>
          </ul>

          <h2>3. A weboldalon használt sütik céljai</h2>
          <p>
            A bazabaukft.hu sütiket használ a weboldal működéséhez, felhasználói élmény javításához, statisztikai mérésekhez, teljesítményméréshez, hirdetésekhez és kampánykövetéshez.
          </p>

          <h2>4. A sütik típusai</h2>

          <h3>4.1. Alapműködést biztosító sütik</h3>
          <p>
            Session sütik, értesítési üzenetek állapota, bejelentkezési adatok, sütibeállítások, anonimizált Analytics sütik.
          </p>

          <h3>4.2. Statisztikai és teljesítménymérő sütik</h3>
          <p>
            Google Analytics, Google Optimize – a felhasználói viselkedést elemzik, személyes azonosítás nélkül.
          </p>

          <h3>4.3. Célzó- és hirdetési sütik</h3>
          <div className="policy-links-grid">
            <div className="policy-link-item">
              <strong>Google Ads (Google Adwords)</strong>
              <a href="https://www.google.com/intl/hu/policies/privacy" target="_blank" rel="noopener noreferrer">Részletes tájékoztató</a>
            </div>
            <div className="policy-link-item">
              <strong>Facebook (Meta)</strong>
              <a href="https://www.facebook.com/help/cookies/" target="_blank" rel="noopener noreferrer">Részletes tájékoztató</a>
            </div>
            <div className="policy-link-item">
              <strong>Instagram</strong>
              <a href="https://help.instagram.com/402411646841720" target="_blank" rel="noopener noreferrer">Részletes tájékoztató</a>
            </div>
            <div className="policy-link-item">
              <strong>TikTok Pixel</strong>
              <a href="https://www.tiktok.com/legal/page/us/privacy-policy/en" target="_blank" rel="noopener noreferrer">Részletes tájékoztató</a>
            </div>
            <div className="policy-link-item">
              <strong>Google Analytics</strong>
              <a href="https://www.google.com/intl/hu/policies/privacy" target="_blank" rel="noopener noreferrer">Részletes tájékoztató</a>
            </div>
            <div className="policy-link-item">
              <strong>Google Tag Manager</strong>
              <a href="https://www.google.com/intl/hu/policies/privacy" target="_blank" rel="noopener noreferrer">Részletes tájékoztató</a>
            </div>
            <div className="policy-link-item">
              <strong>Microsoft Clarity</strong>
              <a href="https://clarity.microsoft.com/privacy" target="_blank" rel="noopener noreferrer">Részletes tájékoztató</a>
            </div>
          </div>

          <h2>5. A sütik kezelése és kikapcsolása</h2>
          <p>
            A felhasználó a böngészőjében bármikor módosíthatja vagy törölheti a sütiket. A tiltás csökkentheti a weboldal működését.
          </p>

          <h2>6. Böngészők süti beállításai</h2>
          <div className="policy-links-grid">
            <div className="policy-link-item">
              <strong>Google Chrome</strong>
              <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Beállítások</a>
            </div>
            <div className="policy-link-item">
              <strong>Mozilla Firefox</strong>
              <a href="https://support.mozilla.org/hu/kb/sutik-engedelyezese-es-tiltasa" target="_blank" rel="noopener noreferrer">Beállítások</a>
            </div>
            <div className="policy-link-item">
              <strong>Microsoft Edge</strong>
              <a href="https://support.microsoft.com/en-us/microsoft-edge/view-cookies-in-microsoft-edge-a7d95376-f2cd-8e4a-25dc-1de753474879" target="_blank" rel="noopener noreferrer">Beállítások</a>
            </div>
            <div className="policy-link-item">
              <strong>Safari (Mac)</strong>
              <a href="https://support.apple.com/hu-hu/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Beállítások</a>
            </div>
          </div>

          <h2>7. Jogszabályi háttér</h2>
          <ul>
            <li>2003. évi C. törvény</li>
            <li>2001. évi CVIII. törvény</li>
            <li>2011. évi CXII. törvény</li>
            <li>2002/58/EK irányelv</li>
            <li>GDPR (EU 2016/679 rendelet)</li>
          </ul>

          <div className="policy-footer-note">
            <p>A jelen szabályzat a 2003. évi C. törvény, a 2001. évi CVIII. törvény, a 2011. évi CXII. törvény, a 2002/58/EK irányelv és a GDPR (EU 2016/679 rendelet) rendelkezései alapján készült.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
